import * as React from 'react';

const Pt16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "red", d: "M6.5 3H13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H6.5z" }), /* @__PURE__ */ React.createElement("path", { fill: "#060", d: "M1 5a2 2 0 0 1 2-2h3.5v10H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#FFCC4D",
    d: "M6.424 4.667C4.541 4.667 3 6.167 3 8s1.54 3.333 3.424 3.333S9.848 9.833 9.848 8s-1.54-3.333-3.424-3.333M3.77 6.583l.685.667-1.027.5c.086-.417.171-.833.342-1.167M3.428 8.25l1.883.917-1.113.75c-.428-.417-.684-1-.77-1.667m2.568 2.667c-.428-.084-.77-.25-1.113-.417h1.113zm0-.834H4.712l1.284-.833zm0-1.333-.257.167L3.942 8l.941-.417zm0-.667-1.54-1.416 1.54.25zm0-1.583-1.883-.333c.428-.584 1.113-.917 1.883-1.084zm3.082.083c.171.334.342.75.342 1.167l-1.027-.5zm-2.226-1.5c.77.084 1.456.5 1.884 1.084L6.852 6.5zm0 1.834 1.541-.25-1.54 1.416zm0 1.833 1.199-1.167.856.417-1.798.917zm0 2.167V10.5h1.113c-.342.167-.685.333-1.113.417m0-.834V9.25l1.284.833zm1.798-.166-1.113-.75L9.42 8.25c-.085.667-.342 1.25-.77 1.667"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#D52B1E",
    d: "M4.456 5.917V8.5c0 1.083.856 1.917 1.969 1.917S8.394 9.583 8.394 8.5V5.917z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M4.97 6.417V8.5c0 .75.685 1.417 1.455 1.417S7.88 9.25 7.88 8.5V6.417z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#039",
    d: "M5.826 7.697h-.6v.75h.6zm.898 0h-.599v.75h.6zm.9 0h-.6v.75h.6zm-.899-1.041h-.599v.75h.6zm0 2.083h-.599v.75h.6z"
  }
));
Pt16.Size = 16;
Pt16.Title = "Pt";

export { Pt16 as default };
